export default __webpack_public_path__ + "static/media/test2.202771fc.png";